<!-- A sent page's delivery mark: the letter first, colour second, and the word
     for screen readers. Pass `page` for a group page's count (D 3/5); a plain
     `status` still works. Screens role. -->
<template>
  <span class="pm-scr-status" :class="`pm-scr-status--${state}`">
    <span aria-hidden="true">{{ mark }}</span>
    <span class="sr-only">{{ word }}</span>
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { STATUS_MARK, STATUS_WORD, deliveryMark, deliveryWord } from '../pm/format.js';

const props = defineProps({
  status: { type: String, default: '' },
  page: { type: Object, default: null },
});

const state = computed(() => props.page?.status ?? props.status);
const mark = computed(() => (props.page ? deliveryMark(props.page) : STATUS_MARK[props.status] ?? ''));
const word = computed(() => (props.page ? deliveryWord(props.page) : STATUS_WORD[props.status] ?? ''));
</script>
